import { render, staticRenderFns } from "./DiscoverOurProducts.vue?vue&type=template&id=5d4fc6e4&scoped=true&"
import script from "./DiscoverOurProducts.vue?vue&type=script&lang=js&"
export * from "./DiscoverOurProducts.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverOurProducts.vue?vue&type=style&index=0&id=5d4fc6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4fc6e4",
  null
  
)

export default component.exports